import { theme } from 'antd';
import { ThemeConfigType } from './typing';
const colorBgContainer = '#141414';
const colorBgLayout = '#000000';

const themeId = 'dark-default';

export const realDarkTheme: ThemeConfigType = {
  id: themeId,
  type: 'dark',
  name: `themes.${themeId}`,
  previewImage: 'https://github.githubassets.com/assets/dark_preview-988b89718a06.svg',
  previewImageDisc: 'https://github.githubassets.com/assets/dark_disc-2bd434b8617d.svg',
  theme: {
    algorithm: [theme.darkAlgorithm],
    token: {
      blue: '#1677FF',
      purple: '#722ED1',
      cyan: '#13C2C2',
      green: '#52C41A',
      magenta: '#EB2F96',
      pink: '#EB2F96',
      red: '#F5222D',
      orange: '#FA8C16',
      yellow: '#FADB14',
      volcano: '#FA541C',
      geekblue: '#2F54EB',
      gold: '#FAAD14',
      lime: '#A0D911',
      colorPrimary: '#177ddc',
      colorSuccess: '#49aa19',
      colorWarning: '#d89614',
      colorError: '#dc4446',
      colorInfo: '#1668dc',
      colorLink: '#1668dc',
      colorTextBase: '#fff',
      colorBgBase: '#000',
      lineWidth: 1,
      lineType: 'solid',
      borderRadius: 6,
      colorText: 'rgba(255, 255, 255, 0.85)',
      colorTextSecondary: 'rgba(255, 255, 255, 0.65)',
      colorTextTertiary: 'rgba(255, 255, 255, 0.45)',
      colorTextQuaternary: 'rgba(255, 255, 255, 0.25)',
      colorFill: 'rgba(255, 255, 255, 0.18)',
      colorFillSecondary: 'rgba(255, 255, 255, 0.12)',
      colorFillTertiary: 'rgba(255, 255, 255, 0.08)',
      colorFillQuaternary: 'rgba(255, 255, 255, 0.04)',
      colorBgLayout: colorBgLayout,
      colorBgContainer: colorBgContainer,
      colorBgElevated: '#1f1f1f',
      colorBgSpotlight: '#424242',
      colorBgBlur: 'rgba(255, 255, 255, 0.04)',
      colorBorder: '#424242',
      colorBorderSecondary: '#303030',
      // colorPrimaryBg: '#111d2c',
      // colorPrimaryBgHover: '#112a45',
      // colorPrimaryBorder: '#15395b',
      // colorPrimaryBorderHover: '#164c7e',
      // colorPrimaryHover: '#3c9ae8',
      // colorPrimaryActive: '#1765ad',
      // colorPrimaryTextHover: '#3c9ae8',
      // colorPrimaryText: '#177ddc',
      // colorPrimaryTextActive: '#1765ad',
      colorSuccessBg: '#162312',
      colorSuccessBgHover: '#1d3712',
      colorSuccessBorder: '#274916',
      colorSuccessBorderHover: '#306317',
      colorSuccessHover: '#306317',
      colorSuccessActive: '#3c8618',
      colorSuccessTextHover: '#6abe39',
      colorSuccessText: '#49aa19',
      colorSuccessTextActive: '#3c8618',
      colorErrorBg: '#2c1618',
      colorErrorBgHover: '#451d1f',
      colorErrorBgActive: '#5b2526',
      colorErrorBorder: '#5b2526',
      colorErrorBorderHover: '#7e2e2f',
      colorErrorHover: '#e86e6b',
      colorErrorActive: '#ad393a',
      colorErrorTextHover: '#e86e6b',
      colorErrorText: '#dc4446',
      colorErrorTextActive: '#ad393a',
      colorWarningBg: '#2b2111',
      colorWarningBgHover: '#443111',
      colorWarningBorder: '#594214',
      colorWarningBorderHover: '#7c5914',
      colorWarningHover: '#7c5914',
      colorWarningActive: '#aa7714',
      colorWarningTextHover: '#e8b339',
      colorWarningText: '#d89614',
      colorWarningTextActive: '#aa7714',
      colorInfoBg: '#111a2c',
      colorInfoBgHover: '#112545',
      colorInfoBorder: '#15325b',
      colorInfoBorderHover: '#15417e',
      colorInfoHover: '#15417e',
      colorInfoActive: '#1554ad',
      colorInfoTextHover: '#3c89e8',
      colorInfoText: '#1668dc',
      colorInfoTextActive: '#1554ad',
      colorLinkHover: '#15417e',
      colorLinkActive: '#1554ad',
      colorBgMask: 'rgba(0, 0, 0, 0.45)',
      colorWhite: '#fff',
      lineWidthBold: 2,
      colorFillContent: 'rgba(255, 255, 255, 0.12)',
      colorFillContentHover: 'rgba(255, 255, 255, 0.18)',
      colorFillAlter: 'rgba(255, 255, 255, 0.04)',
      colorBgContainerDisabled: 'rgba(255, 255, 255, 0.08)',
      colorBorderBg: '#141414',
      colorSplit: 'rgba(253, 253, 253, 0.12)',
      colorTextPlaceholder: 'rgba(255, 255, 255, 0.25)',
      colorTextDisabled: 'rgba(255, 255, 255, 0.25)',
      colorTextHeading: 'rgba(255, 255, 255, 0.85)',
      colorTextLabel: 'rgba(255, 255, 255, 0.65)',
      colorTextDescription: 'rgba(255, 255, 255, 0.45)',
      colorTextLightSolid: '#fff',
      colorHighlight: '#dc4446',
      colorBgTextHover: 'rgba(255, 255, 255, 0.12)',
      colorBgTextActive: 'rgba(255, 255, 255, 0.18)',
      colorIcon: 'rgba(255, 255, 255, 0.45)',
      colorIconHover: 'rgba(255, 255, 255, 0.85)',
      colorErrorOutline: 'rgba(238, 38, 56, 0.11)',
      colorWarningOutline: 'rgba(173, 107, 0, 0.15)',
      controlItemBgHover: 'rgba(255, 255, 255, 0.08)',
      controlItemBgActive: '#111d2c',
      controlItemBgActiveHover: '#112a45',
      controlItemBgActiveDisabled: 'rgba(255, 255, 255, 0.18)',
      controlTmpOutline: 'rgba(255, 255, 255, 0.04)',
      controlOutline: 'rgba(0, 80, 180, 0.15)',
      linkDecoration: 'none',
      linkHoverDecoration: 'none',
      linkFocusDecoration: 'none',
      boxShadow:
        '\n      0 6px 16px 0 rgba(0, 0, 0, 0.08),\n      0 3px 6px -4px rgba(0, 0, 0, 0.12),\n      0 9px 28px 8px rgba(0, 0, 0, 0.05)\n    ',
      boxShadowSecondary:
        '\n      0 6px 16px 0 rgba(0, 0, 0, 0.08),\n      0 3px 6px -4px rgba(0, 0, 0, 0.12),\n      0 9px 28px 8px rgba(0, 0, 0, 0.05)\n    ',
      boxShadowTertiary:
        '\n      0 1px 2px 0 rgba(0, 0, 0, 0.03),\n      0 1px 6px -1px rgba(0, 0, 0, 0.02),\n      0 2px 4px 0 rgba(0, 0, 0, 0.02)\n    ',
    },
  },
  layout: {
    hashId: themeId,
    colorPrimary: '#177ddc',
    colorBgAppListIconHover: 'rgba(255, 255, 255, 0.04)',
    colorTextAppListIconHover: '#fff',
    colorTextAppListIcon: 'rgba(255, 255, 255, 0.65)',
    bgLayout: `linear-gradient(${colorBgContainer}, ${colorBgLayout} 28%)`,
    sider: {
      paddingInlineLayoutMenu: 8,
      paddingBlockLayoutMenu: 0,
      colorBgCollapsedButton: '#1f1f1f',
      colorTextCollapsedButtonHover: 'rgba(255, 255, 255, 0.65)',
      colorTextCollapsedButton: 'rgba(255, 255, 255, 0.25)',
      colorMenuBackground: 'transparent',
      colorMenuItemDivider: 'rgba(255, 255, 255, 0.06)',
      colorBgMenuItemHover: 'rgba(255, 255, 255, 0.03)',
      colorBgMenuItemSelected: 'rgba(255, 255, 255, 0.04)',
      colorTextMenuItemHover: 'rgba(255, 255, 255, 0.85)',
      colorTextMenuSelected: 'rgba(255, 255, 255, 0.95)',
      colorTextMenuActive: 'rgba(255, 255, 255, 0.85)',
      colorTextMenu: 'rgba(255, 255, 255, 0.65)',
      colorTextMenuSecondary: 'rgba(255, 255, 255, 0.45)',
      colorTextMenuTitle: 'rgba(255, 255, 255, 0.85)',
      colorTextSubMenuSelected: 'rgba(255, 255, 255, 0.95)',
    },
    header: {
      colorBgHeader: 'rgba(31, 31, 31, 0.6)',
      colorBgScrollHeader: 'rgba(31, 31, 31, 0.8)',
      colorHeaderTitle: 'rgba(255, 255, 255, 0.85)',
      colorBgMenuItemHover: 'rgba(255, 255, 255, 0.03)',
      colorBgMenuItemSelected: 'transparent',
      colorTextMenuSelected: 'rgba(255, 255, 255, 0.95)',
      colorBgRightActionsItemHover: 'rgba(255, 255, 255, 0.03)',
      colorTextRightActionsItem: 'rgba(255, 255, 255, 0.45)',
      heightLayoutHeader: 56,
      colorTextMenu: 'rgba(255, 255, 255, 0.65)',
      colorTextMenuSecondary: 'rgba(255, 255, 255, 0.45)',
      colorTextMenuActive: 'rgba(255, 255, 255, 0.85)',
    },
    pageContainer: {
      colorBgPageContainer: 'transparent',
      paddingInlinePageContainerContent: 40,
      paddingBlockPageContainerContent: 32,
      colorBgPageContainerFixed: '#1f1f1f',
    },
  },
};
